import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



import Pagination from "../src/components/Pagination";
Vue.component('Pagination', Pagination)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)


// import '@/assets/font_2929894_.js'
Vue.use(ElementUI);

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree ,getUrlKey } from "@/utils/ruoyi";

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.getUrlKey = getUrlKey


Vue.config.productionTip = false

// import "@/assets/js/jquery.js"
// import "@/assets/js/owl.carousel.js"



// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  /* 需要注册百度地图开发者来获取你的ak */
  ak: 'RFTpvCEkq2vFODGyGfioa00UXraki35B'
})



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
